import React = require("react");
import {ReactNode} from "react";
import "./PeriodChanger.scss";

export enum PeriodSelection {
    Week,
    Month,
    Year,
    Rolling4Weeks,
    RollingQuarter,
    RollingSemester,
    RollingYear,
}

interface PeriodChangerProps {
    period: PeriodSelection;
    onPeriodSelection: (s: PeriodSelection) => any;
    textMonth: string;
    textRollingYear: string;
    textYear: string;
    textRolling4Weeks: string;
    textRollingQuarter: string;
    textRollingSemester: string;
    textWeek: string;
}

export class PeriodChanger extends React.Component<PeriodChangerProps, {}> {

    /**
     * Build a button. If it is selected the onSelect function is never called.
     */
    private static buildButton(text: string, selected: boolean, onSelect: () => any): ReactNode {
        return (
            <div
                className={"period-changer__button " + (selected ? "period-changer__button--selected" : "")}
                onClick={() => {
                    if (!selected) {
                        onSelect();
                    }
                }}
            >
                <p>{text}</p>
            </div>
        );
    }

    constructor(props: PeriodChangerProps) {
        super(props);
    }

    public render(): ReactNode {
        const month: ReactNode = PeriodChanger.buildButton(
            this.props.textMonth,
            this.props.period === PeriodSelection.Month,
            () => this.props.onPeriodSelection(PeriodSelection.Month),
        );
        const rollingYear: ReactNode = PeriodChanger.buildButton(
            this.props.textRollingYear,
            this.props.period === PeriodSelection.RollingYear,
            () => this.props.onPeriodSelection(PeriodSelection.RollingYear),
        );

        const year: ReactNode = PeriodChanger.buildButton(
            this.props.textYear,
            this.props.period === PeriodSelection.Year,
            () => this.props.onPeriodSelection(PeriodSelection.Year),
        );
        const rolling4Weeks: ReactNode = PeriodChanger.buildButton(
            this.props.textRolling4Weeks,
            this.props.period === PeriodSelection.Rolling4Weeks,
            () => this.props.onPeriodSelection(PeriodSelection.Rolling4Weeks),
        );
        const rollingQuarter: ReactNode = PeriodChanger.buildButton(
            this.props.textRollingQuarter,
            this.props.period === PeriodSelection.RollingQuarter,
            () => this.props.onPeriodSelection(PeriodSelection.RollingQuarter),
        );
        const rollingSemester: ReactNode = PeriodChanger.buildButton(
            this.props.textRollingSemester,
            this.props.period === PeriodSelection.RollingSemester,
            () => this.props.onPeriodSelection(PeriodSelection.RollingSemester),
        );
        const week: ReactNode = PeriodChanger.buildButton(
            this.props.textWeek,
            this.props.period === PeriodSelection.Week,
            () => this.props.onPeriodSelection(PeriodSelection.Week),
        );

        return (
            <div className="period-changer">
                <div className="period-changer__row period-changer__row--extended">
                    {week}
                    {month}
                    {year}
                    {rolling4Weeks}
                    {rollingQuarter}
                    {rollingSemester}
                    {rollingYear}
                </div>

            </div>
        );
    }
}
